const StatusBox = ({ children }) => {
  return <h2 className="status-box">{children}</h2>;
};

export default StatusBox;
